const styles = {
  marginTop5: { marginTop: '5px' },
};
export default styles;
